// ./src/hooks/useTimeFormat.tsx
import { useMemo } from "react";

export const useTimeFormat = () => {
  const is12Hour = useMemo(() => {
    try {
      const formatter = new Intl.DateTimeFormat(navigator.language, {
        hour: "numeric",
      });
      const parts = formatter.formatToParts(new Date());
      return parts.some((part) => part.type === "dayPeriod");
    } catch {
      return false; // Default to 24h if detection fails
    }
  }, []);

  return { is12Hour };
};
